import React from 'react';
import Link from 'next/link';
import round from 'lodash/round';
import SvgLocation from './SvgLocation';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { CityContext } from '@/context/create-context';

const VISIBLE_COUNT = 5;

const CitySalaryRank = () => {
  const { adjacent_cities } = React.useContext(CityContext);
  const [expanded, setExpanded] = React.useState(false);

  if (
    adjacent_cities &&
    Array.isArray(adjacent_cities) &&
    adjacent_cities.length > 0
  ) {
    return (
      <div className="p-6 rounded-lg bg-web-grey-400 my-10">
        <div className="flex items-center">
          <SvgLocation className="shrink-0" />
          <span className="ml-2 text-xl font-semibold">城市平均月薪榜单</span>
        </div>
        <ul className="list-none !ml-0 text-sm font-semibold">
          {adjacent_cities.map(({ avg, rank, pinyin, name }, index) => (
            <li
              key={index}
              className={`mt-6 flex ${
                !expanded && index >= VISIBLE_COUNT ? 'hidden' : ''
              }`}
            >
              <span
                className={`block w-6 h-6 rounded-full shrink-0 flex items-center justify-center ${
                  index === 0
                    ? 'text-web-earth-600 bg-web-earth-200'
                    : index === 1
                      ? 'text-web-neutral-800 bg-web-neutral-200'
                      : index === 2
                        ? 'text-web-orange-600 bg-web-orange-200'
                        : 'text-web-blue-700 bg-web-blue-200'
                }`}
              >
                {rank}
              </span>
              <Link
                href={`/${pinyin}/`}
                title={name}
                className="block ml-2 line-clamp-1 hover:underline"
              >
                {name}
              </Link>
              <span className="shrink-0 ml-auto">{`¥${round(avg, -2)}`}</span>
            </li>
          ))}
        </ul>
        {adjacent_cities.length > VISIBLE_COUNT && (
          <div className="flex justify-center items-center mt-2">
            <span
              role="button"
              tabIndex={0}
              onClick={() => setExpanded((prev) => !prev)}
              aria-expanded={expanded}
              className="rounded-full flex justify-center items-center text-primary hover:bg-web-grey-50 active:bg-black/20 transition-colors focus:outline-none"
            >
              {expanded ? (
                <KeyboardArrowUpIcon fontSize="medium" />
              ) : (
                <KeyboardArrowDownIcon fontSize="medium" />
              )}
            </span>
          </div>
        )}
      </div>
    );
  }
  return null;
};

export default CitySalaryRank;
